import axios from "axios";
const base_path = window.APP_CONFIG?.BASE_URL;

//get all
export const getAllWishlist = async (UserGuId) => {
  try{
  const response = await axios.get(`${base_path}/api/Wishlist/GetAll?UserGuId=${UserGuId}`);
  return response.data;
  } catch (error){
    console.error("Error fetching wishlist :",error);
    throw error;
  }
};
//ADD
export const addProductToUserWishlist = async (wishlistData) => {
  try{
  const response= await axios.post(`${base_path}/api/wishlist/Save`,wishlistData);
  return response.data;
  }catch(error){
    console.error("Error fetching wishlist :",error);
    throw error;
  }
};
//remove
export const removeProductFromUserWishlist = async (wishlistData) => {
  try{
 const response= await axios.post(`${base_path}/api/WishList/Delete`,wishlistData)
 return response.data;
  }catch(error){
    console.error("Error fetching wishlist :",error);
    throw error;
  }
};
//clear wishlist
export const clearUserWishlist = async (wishlistData) => {
  try {
    await axios.post(`${base_path}/api/WishList/ClearWishList`, wishlistData);
  } catch (error) {
    console.error("Error clearing wishlist:", error);
    throw error;
  }
 
};